import { Box, Alert, Typography } from '@mui/material';
import { Header } from 'components/layouts';
import { StyledPaper, StyledLink, Paragraph, SectionDivider } from 'components/layouts/SharedStyles';
import { mailtoLink, websiteLink } from 'utils/misc';
import { useOrderData } from 'contexts/OrderDataContext';
import { useOrderPayment } from 'contexts/OrderPaymentContext';
import { config } from 'config';

export const Confirmation = () => {
  const { receipt } = useOrderData();
  const { paymentMethod } = useOrderPayment();

  if (!receipt) throw new Error('No receipt found in order data context');

  return (
    <>
      {!config.registrationOnly &&
        <Header
          titleText = { paymentMethod === 'check'
            ? `${config.event.title} Registration`
            : `${config.event.title} Confirmation`
          }
        />
      }


      <StyledPaper>
        <Alert severity='warning'>
          <Typography variant='h6' gutterBottom>
            Action Required: Complete Camp Sealth Waiver
          </Typography>
          <Typography>Your registration is not complete until you fill out Camp Sealth's waiver at <StyledLink to="https://form.fillout.com/t/d7NomR6sSvus">https://form.fillout.com/t/d7NomR6sSvus</StyledLink>. Please do so now so that you don't lose your spot at camp.</Typography>
        </Alert>

        <Paragraph>
          Thank you for filling out the registration form to join us at Northwest Queer Contra Camp 2026!
          You will be emailed this registration form's information for your records.
          You can find information about camp at <StyledLink to={websiteLink(config.links.info)}>{config.links.info}</StyledLink> and we will email you more details in the weeks before camp.
          If you have any questions, please contact us at <StyledLink to={mailtoLink(config.contacts.info)}>{config.contacts.info}</StyledLink>.
        </Paragraph>

        <SectionDivider />

        <div dangerouslySetInnerHTML={{ __html: receipt }} />

        <Box my={2} />
      </StyledPaper>
    </>
  );
};
